export class EventPriceBenefit {
  public EventPriceBenefitId: number;
  public EventPriceId: number;
  public EventBenefitId: number;
  public EventPriceDescr: string;
  public Selected: boolean;

  public constructor() {
    this.EventPriceBenefitId = 0;
    this.EventPriceId = 0;
    this.EventBenefitId = 0;
    this.EventPriceDescr = '';
    this.Selected = false;
  }
}
